// src/utils/dateInput.js
//
// Dată scrisă de mână în format ZZ.LL.AAAA (fără selector de calendar):
// mascăm cifrele pe măsură ce sunt tastate, validăm că e o zi reală și
// acceptăm la încărcarea drafturilor vechi și forma ISO (AAAA-LL-ZZ).

export const DATE_INPUT_PLACEHOLDER = "ZZ.LL.AAAA";
export const DATE_INPUT_PATTERN = "\\d{2}\\.\\d{2}\\.\\d{4}";

const onlyDigits = (value) => String(value ?? "").replace(/\D+/g, "");
const pad2 = (value) => String(value).padStart(2, "0");

/** Cifrele tastate → „ZZ.LL.AAAA" progresiv („1205" → „12.05", „12051995" → „12.05.1995”). */
export function formatDateInput(raw) {
   const digits = onlyDigits(raw).slice(0, 8);
   if (digits.length <= 2) return digits;
   if (digits.length <= 4) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
   return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`;
}

function parseParts(text) {
   const match = String(text ?? "")
      .trim()
      .match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
   if (!match) return null;
   return { day: Number(match[1]), month: Number(match[2]), year: Number(match[3]) };
}

/** Doar date reale din calendar, între 1900 și anul următor. */
export function isValidDateInput(text) {
   const parts = parseParts(text);
   if (!parts) return false;
   const { day, month, year } = parts;
   const maxYear = new Date().getFullYear() + 1;
   if (year < 1900 || year > maxYear) return false;
   if (month < 1 || month > 12) return false;
   const daysInMonth = new Date(year, month, 0).getDate();
   return day >= 1 && day <= daysInMonth;
}

/** Orice formă cunoscută („AAAA-LL-ZZ", „ZZ.LL.AAAA", ISO cu oră, cifre) → „ZZ.LL.AAAA". */
export function dateInputFromAny(value) {
   const text = String(value ?? "").trim();
   if (!text) return "";

   const iso = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
   if (iso) return `${iso[3]}.${iso[2]}.${iso[1]}`;

   const dotted = text.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
   if (dotted) return `${pad2(dotted[1])}.${pad2(dotted[2])}.${dotted[3]}`;

   return formatDateInput(text);
}

/** „ZZ.LL.AAAA" → „AAAA-LL-ZZ" (gol dacă data nu e validă). */
export function dateInputToIso(text) {
   const parts = parseParts(text);
   if (!parts || !isValidDateInput(text)) return "";
   return `${parts.year}-${pad2(parts.month)}-${pad2(parts.day)}`;
}
